@use "../../styles/breakpoint.module.scss" as *;

.root {
    display: flex;
    gap: var(--spacer-40);
    margin-bottom: var(--spacer-24);

    @media ($below-mobile) {
        flex-direction: column;
        gap: var(--spacer-16);
    }
}

.richText {
    & :is(p, li) {
        color: rgb(var(--color-contrast-base) / 60%);
        font: var(--font-fineprint);
    }
}

.cta {
    color: rgb(var(--color-contrast-base) / 60%);
    font: var(--font-fineprint);
    flex-shrink: 0;

    svg {
        width: 1em;
        height: 1em;
        margin-left: 0.5em;
        fill: currentColor;
        transform: translateY(0.1em);
    }
}
